"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const styles = {
    container: {
        backgroundColor: '#fd000c',
        borderRadius: '5px',
        padding: '0.4rem',
    },
    text: {
        color: 'white',
        margin: '0.5px',
        fontSize: '0.9em',
        listStyle: 'inside',
    },
};
const getErrors = (errorObj) => {
    const result = [];
    function errorsIterators(obj) {
        for (const key in obj) {
            if (typeof obj[key] === 'object') {
                errorsIterators(obj[key]);
            }
            else {
                result.push(obj[key]);
            }
        }
    }
    errorsIterators(errorObj);
    return result;
};
function FormikErrorsSummary({ style }) {
    const { errors, isValid } = (0, formik_1.useFormikContext)();
    const errorList = (0, react_1.useMemo)(() => {
        return getErrors(errors);
    }, [errors]);
    if (isValid)
        return (0, jsx_runtime_1.jsx)("div", {});
    return ((0, jsx_runtime_1.jsx)("ul", { style: { ...styles.container, ...style?.container }, children: errorList.map((errorText, index) => {
            return (
            // eslint-disable-next-line react/no-array-index-key
            (0, jsx_runtime_1.jsx)("li", { style: { ...styles.text, ...style?.text }, children: errorText }, index));
        }) }));
}
exports.default = FormikErrorsSummary;
